import Badge, { ColorType } from '@/common/components/Badge'
import { ProviderBankAccountStatus } from '@/schemas/provider.schema'

interface Props {
  status: ProviderBankAccountStatus
}

function getColor(status: ProviderBankAccountStatus): ColorType {
  switch (status) {
    case 'In Review':
      return 'Notice'
    case 'Accepted':
      return 'Positive'
    case 'Rejected':
      return 'Negative'
    default:
      return 'Neutral'
  }
}

function getLabel(status: ProviderBankAccountStatus) {
  switch (status) {
    case 'Accepted':
      return 'Added'
    default:
      return status ?? 'Not Added'
  }
}

function ProviderBankAccountStatusBadge(props: Props) {
  const { status } = props

  return <Badge semanticColor={getColor(status)}>{getLabel(status)}</Badge>
}

export default ProviderBankAccountStatusBadge
